<template>
  <div>
    <h4>网点现场资料采集列表</h4>
    <div class="my-table">
      <el-table
        :data="dataList"
        max-height="650"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          fixed
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          align="center"
          label="申报ID"
          prop="id"
          width="50">
        </el-table-column>
        <el-table-column
          align="center"
          label="日期"
          prop="modTime"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          label="地理位置"
          prop="addressText"
          width="120">
        </el-table-column>
        <el-table-column
          align="center"
          label="上报人员"
          prop="userAccount"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          label="资料完整度"
          prop="completeness"
          width="120">
        </el-table-column>
        <el-table-column
          align="center"
          label="网点状态"
          prop="status"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="orange-text">待审核</span>
            <span v-else-if="scope.row.status == 1" class="green-text">已通过</span>
            <span v-else-if="scope.row.status == 2" class="red-text">已拒绝</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="80">
          <template slot-scope="scope">
            <button class="button edit" @click="queryMaterial(scope.row)">查看</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {queryUploadPosApplyDetail} from "../api";


export default {
  data() {
    return {
      // modTime: "", //上报时间
      // userAccount: "", //上报人员
      // status: "", //网点状态
      // addressText: "", //地理位置
      dataList: [],
      page: 0,
      size: 20,
    };
  },

  mounted() {
    this.getMaterial();

  },
  methods: {

    //获取网点资料列表
    getMaterial() {
      let params = {
        page: '0',
        size: '100'
      }
      queryUploadPosApplyDetail(params).then((res) => {
        console.log("查询网点资料列表拦截", res)
        this.dataList = res.data._embedded.myUrls;
        this.dataList.reverse();
        for (const item of this.dataList) {
          const completeness = this.completenessPercentage(item);
          this.$set(item, "completeness", completeness)
        }
      });
    },

    //查看网点上传资料完整度的方法
    completenessPercentage(item) {
      let nonEmptyCount = 0;
      const totalProperties = Object.keys(item).length;
      for (const key in item) {
        if (item[key] && item[key] !== "[]") {
          nonEmptyCount++;
        }
      }
      const completenessPercentage = Math.round((nonEmptyCount / totalProperties) * 100);
      return completenessPercentage + "%";
    },

    //查询按钮，查询网点现场资料具体信息
    queryMaterial(item) {
      console.log('查询');
      this.$router.push({
        name: 'material_collection',
        params: {
          object: item,
        }
      })
    },
  },
};
</script>

<style scoped>
/*.table {
  width: 100%;
  margin-top: 20px;
}

thead tr td {
  font-size: 14px;
  font-weight: bolder;
  white-space: nowrap;
  !*overflow-x: auto;*!
}

thead tr {
  font-weight: bold;
  text-align: center;
  position: sticky;
}


td {
  border-bottom: 1px solid rgba(229, 229, 229, 1);

}


tbody tr td {
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  word-wrap: break-word;
}

tbody tr:nth-child(even) {
  background: #fafafa;
}*/
.my-table {
  margin-top: 10px;
}

.button {
  border-radius: 5px;
  margin: 5px 0;
}

.edit {
  width: 58px;
  height: 26px;
  background: #409EFF;
  color: white;
  border: 0;
}

.orange-text {
  color: orange !important;
}

.green-text {
  color: green !important;
}

.red-text {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/material_query.vue